import { maskPercentage } from '../../masks/masks'

const format = (
  value?: number,
  fractional?: number,
  prefixMoney?: boolean,
  def?: number,
  currency: 'brl' | 'usd' = 'brl'
): string => {
  if (value === undefined || value === null) {
    value = def
  }

  if (value === undefined || value === null) {
    return ''
  }

  var money = ''

  if (prefixMoney) {
    money = value.toLocaleString('pt-br', {
      style: 'currency',
      currency: currency === 'usd' ? 'USD' : 'BRL',
    })
    return money
  }

  money = value.toLocaleString('pt-br', { minimumFractionDigits: fractional })
  return money
}

const formatMoney = (
  value?: number,
  prefixMoney?: boolean,
  def?: number,
  currency: 'brl' | 'usd' = 'brl'
) => {
  return format(value, 2, prefixMoney, def, currency)
}

const formatMoneyDefault = (value?: any, currency: 'brl' | 'usd' = 'brl') => {
  const number = toNumber(value)
  return formatMoney(number, true, 0, currency)
}

const toNumber = (value: any) => {
  if (typeof value === 'string') {
    value = String(value).replace(',', '.')
    return Number(value)
  }
  if (value !== undefined && value !== null) {
    return Number(value)
  }
  return value
}

const toPercentage = (value?: any) => {
  value = toNumber(value || 0)
  const percentage = Number(value).toLocaleString('pt-br', {
    maximumFractionDigits: 2,
  })
  return `${percentage}%`
}

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max)
}

const maskPercentageToNumber = (value: string) => {
  return toNumber(maskPercentage(value).replaceAll('.', '').replace(',', '.'))
}

const maskMoneyToNumber = (value: string): number => {
  const cleaned = value
    .replace('R$', '')
    .replaceAll('.', '')
    .replace(',', '.')
    .trim()
  return Number(cleaned) || 0
}

const roundTo = (value: number, decimals: number = 2): number => {
  const factor = Math.pow(10, decimals)
  return Math.round(value * factor) / factor
}

const NumberFunctions = {
  format,
  formatMoney,
  formatMoneyDefault,
  toNumber,
  toPercentage,
  getRandomInt,
  maskPercentageToNumber,
  maskMoneyToNumber,
  roundTo,
}

export default NumberFunctions
